<template>
    <div :class="[textAlignmentClass, 'q-pa-sm']" style="max-width: 800px; margin: 0 auto;">
        <div>
            <div v-if="field.options?.title" class="text-weight-medium text-h6">
                <span v-html="formatDisplayText(field.options.title)" />
            </div>
            <div v-if="field.options?.subtitle" class="text-body1 text-grey-8">
                <span v-html="formatDisplayText(field.options.subtitle)" />
            </div>
            <div v-if="field.options?.body" class="text-body1">
                <span v-html="formatDisplayText(field.options.body)" />
            </div>
            <div v-if="field.label && !field.options?.title" class="q-mb-xs text-h6 text-bold">
                <span v-html="formatDisplayText(field.label)" />
            </div>
            <div v-if="field.sublabel" class="text-caption text-grey-7">
                <span v-html="formatDisplayText(field.sublabel)" />
            </div>
            <ul v-if="displayItems.length" class="display-text-list text-body1">
                <li v-for="(item, index) in displayItems" :key="`display-text-item-${index}`">
                    <span v-html="formatDisplayText(item)" />
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'DisplayTextField',
        props: {
            field: {
                type: Object,
                required: true,
            },
        },
        computed: {
            displayItems() {
                const items = this.field.options?.items;
                if (!Array.isArray(items)) return [];
                return items
                    .filter((item) => typeof item === 'string')
                    .map((item) => item.trim())
                    .filter(Boolean);
            },
            textAlignmentClass() {
                const alignment = this.field.options?.align;
                if (['left', 'right', 'center'].includes(alignment)) {
                    return `text-${alignment}`;
                }
                return 'text-center';
            },
        },
        methods: {
            // Format display text with basic markdown support (bold with **text**) and line breaks, while escaping HTML chars
            formatDisplayText(value) {
                const text = String(value ?? '');
                return this.escapeHtml(text)
                    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
                    .replace(/\n/g, '<br>');
            },
            escapeHtml(value) {
                return value
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;')
                    .replace(/'/g, '&#39;');
            },
        },
    };
</script>

<style scoped>
    .display-text-list {
        margin: 0.75rem 0 0;
        padding-left: 1.5rem;
    }

    .display-text-list li + li {
        margin-top: 0.35rem;
    }
</style>